const ESaleStatus = {
  /******** NEW STATUS ********/
  NEW: 0,
  GIVE_UP: 6,
  ABANDONED: 7,
  PARTIAL_CANCELED: 8,
  CANCELED: 9,
  UNDEFINED: 99,
  /******** PAYMENT ********/
  PENDING_PAYMENT: 10,
  PAYMENT_MADE: 11,
  REQUEST_REFUND_PAYMENT: 12,
  PAYMENT_PARTIAL_REFUNDED: 13,
  PAYMENT_FULLY_REFUNDED: 14,
  PARTIAL_REFUND_REJECTED: 15,
  FULLY_REFUND_REJECTED: 16,
  PAYMENT_CHANGED: 17,
  PAYMENT_CANCELED: 18,
  REFUSED_PAYMENT: 19,
  /******** DOCAS ********/
  WAITING_DOCAS_APPROVE: 20,
  DOCAS_APPROVED: 21,
  DOCAS_PARTIAL_APPROVED: 22,
  WAITING_DISTRIBUTION_CENTER: 23,
  DISTRIBUTION_CENTER_DELIVERED: 28,
  DOCAS_REFUSED: 29,
  /******** DELIVERY ********/
  PREPARING_DELIVERY: 30,
  PARTIAL_DELIVERED: 31,
  OUT_DELIVERY: 32,
  WAITING_WITHDRAWAL: 33,
  WAITING_WITHDRAWAL_LOCKER: 34,
  DELIVERY_MADE: 39,
  /**Erros de processamento na criação do pagamento */
  FAIL_PAYMENT: 40,
  FAIL_PAYMENT_CANCELED: 41
};

const EProductStatus = {
  /******** STATUS ********/
  NEW: 0,
  WAITING_REFUND_PAYMENT: 6,
  PAYMENT_REFUNDED: 7,
  PRODUCT_CANCELED: 8,
  PRODUCT_REMOVED: 9,
  /******** DELIVERY ********/
  WAITING_DISTRIBUTION_CENTER: 10,
  PREPARING_DELIVERY: 11,
  OUT_DELIVERY: 12,
  WAITING_WITHDRAWAL: 13,
  STORE_PICKUP: 18,
  DELIVERY_MADE: 19
};

export { ESaleStatus, EProductStatus };
